import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { LAYER } from 'js/components/common/PopupManager';
import { showConfirmationPopupAction } from 'js/components/common/popups/ConfirmationPopup';

import { ITermsNotificationOptions } from '../../types';

import style from './TermsNotification.scss';

export const useHandleTermsNotification = () => {
    const dispatch = useDispatch();

    // TODO add 31011 onAccept
    return useCallback((options: ITermsNotificationOptions): void => {
        dispatch(showConfirmationPopupAction({
            layer: LAYER.HIGH_PRIORITY,
            closeAll: true,
            isModal: true,
            title: 'playtech.mobile.system.popup.TC.title',
            content: `<div class=${style.container}><iframe src="${options?.data?.tcVersionUrl}"></iframe></div>`,
            acceptBtnText: 'playtech.mobile.system.message.accept',
            declineBtnText: 'playtech.mobile.system.message.decline',
            ...options.data
        }));
    }, [dispatch]);
};
